export default __webpack_public_path__ + "static/media/Padron_FamReserev.f71b4d60.jpg";